/**
 * Sblocco effimero di un campo in modalità «Con sblocco» (feature 150): un lucchetto apre il campo
 * per una digitazione e il campo si richiude da solo quando perde il fuoco.
 *
 * Ricalca la logica di LottoInputComponent (issue #3462), che resta com'è. Stato per campo, non
 * persistito: un'istanza per ogni campo bloccabile, e `dispose()` nel ngOnDestroy del componente.
 */
export class SbloccoEffimero {
  private aperto = false;
  private richiusuraTimer: ReturnType<typeof setTimeout> | null = null;

  get sbloccato(): boolean {
    return this.aperto;
  }

  /**
   * Inverte lo stato. `onApertura` gira in un macrotask (serve per il setFocus: il campo deve aver
   * già perso il readonly), e solo quando il campo si apre.
   */
  alterna(onApertura?: () => void): void {
    // Annullare la richiusura pendente è la parte che fa funzionare il lucchetto: col fuoco già nel
    // campo, il tap sul lucchetto produce prima il blur (che programma la richiusura) e SOLO DOPO il
    // click. Senza questo, la richiusura girerebbe dopo lo sblocco e lo annullerebbe.
    this.cancellaRichiusura();
    this.aperto = !this.aperto;
    if (this.aperto && onApertura) {
      setTimeout(onApertura, 0);
    }
  }

  /**
   * Da chiamare al blur del campo. Il setTimeout non è cosmesi: in Ionic 7 ionChange viene emesso
   * DURANTE la gestione del blur, e rimettere readonly in modo sincrono rischia di sopprimerlo.
   */
  richiudiAlBlur(): void {
    this.cancellaRichiusura();
    this.richiusuraTimer = setTimeout(() => {
      this.aperto = false;
      this.richiusuraTimer = null;
    }, 0);
  }

  dispose(): void {
    this.cancellaRichiusura();
  }

  private cancellaRichiusura(): void {
    if (this.richiusuraTimer !== null) {
      clearTimeout(this.richiusuraTimer);
      this.richiusuraTimer = null;
    }
  }
}
